import { typedBoolean } from "../helper";
export const transFacetsToIndex = (facets_to_index) => ({
    facetsToIndex: [...(facets_to_index || [])].map((i) => i.facet_name_in_locale_language || "").filter(typedBoolean),
});
